@if (relatives().length > 0) {
	<cdk-accordion class="relatives-accordion" [multi]="true">
		<cdk-accordion-item #accordionItem="cdkAccordionItem" [expanded]="true" class="lvr-shared-list">
			<div
				class="lvr-shared-list__header"
				[attr.id]="'relatives-accordion-header-' + title()"
				[attr.aria-expanded]="accordionItem.expanded"
				[attr.aria-controls]="'relatives-accordion-body-' + title()"
			>
				<h3>{{ title() }}</h3>
			</div>
			@if (accordionItem.expanded) {
				<div
					class="lvr-shared-list__body"
					role="region"
					[attr.id]="'relatives-accordion-body-' + title()"
					[attr.aria-labelledby]="'relatives-accordion-header-' + title()"
				>
					@for (relative of relatives(); track relative.id) {
						<a class="lvr-shared-list__record link" [routerLink]="[relative.id]">
							<lvr-client-relatives-item [relative]="relative"></lvr-client-relatives-item>
						</a>
					}
				</div>
			}
		</cdk-accordion-item>
	</cdk-accordion>
} @else {
	<h3>
		{{ title() }}
	</h3>
	<p>{{ 'client.relatives.no_data' | transloco }}</p>
}
